export default __webpack_public_path__ + "static/media/carousel-img-10.5fa015cb.webp";